import React, {Component} from 'react';
import TopMenu from '../components/TopMenu';
import {Helmet} from 'react-helmet';
import MaterialIcon from '../components/MaterialIcon';
import SegmentationCreation from "../components/Segmentation/SegmentationCreation";
import SegmentationsList from "../components/Segmentation/SegmentationsList";
import {Navigate} from "react-router-dom";

class Segmentations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCreatingSegmentation: false,
            isModalVisible: false,
            chartUpdate: {
                date: '',
            },
        };
    }

    toggleCreateSegmentation = () => {
        this.setState((prevState) => ({
            isCreatingSegmentation: !prevState.isCreatingSegmentation,
            isModalVisible: !prevState.isCreatingSegmentation,
        }));
    };

    toggleModal = () => {
        this.setState({
            isModalVisible: false,
            isCreatingSegmentation: false,
        });
    };

    updateChart = () => {
        const newDate = new Date().toISOString();
        this.setState({
            chartUpdate: {date: newDate},
        });
    };
    hasNotAccess() {
        return this.props.privileges['Segmentations'] === "no access";
    }

    isReadOnly() {
        return this.props.privileges['Segmentations'] === "read-only";
    }

    render() {
        if (this.hasNotAccess()) {
            return <Navigate to="/"/>;
        }

        return (
            <div className="segmentation-page">
                <Helmet>
                    <title>Analytics</title>
                </Helmet>
                <TopMenu/>
                <div className="segmentation-secondary-menu">
                    {!this.state.isCreatingSegmentation && !this.isReadOnly() ? (
                        <button className="add-segmentation-button" onClick={this.toggleCreateSegmentation}>
                            <MaterialIcon icon="add" size={24}/>
                            <span>Add New</span>
                        </button>
                    ) : null}

                    {this.state.isModalVisible && (
                        <SegmentationCreation onCancel={this.toggleModal} onSegmentationChange={this.updateChart}/>
                    )}
                </div>
                <SegmentationsList chartUpdate={this.state.chartUpdate}
                                   key={this.state.chartUpdate.date}
                                   isReadOnly={this.isReadOnly()}></SegmentationsList>
            </div>
        );
    }
}

export default Segmentations;


